import { render, staticRenderFns } from "./fpagos.vue?vue&type=template&id=286a9b0b"
import script from "./fpagos.vue?vue&type=script&lang=js"
export * from "./fpagos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports